
import Heading from "./Heading";
import AnchorLink from "./AnchorLink";



const FullContent = (props) => {
    const {heading,image,description,buttonObject} = props
    return (
        <>
            <div>
                <Heading 
                    heading={heading || 'No Heading'}
                />            
            </div>

            {image &&
                <div className="image mt-5">
                    <img 
                        alt='Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
                        src={'https://placehold.co/1200x500/jpg'}
                        width={0}
                        height={0}
                        sizes="100vw"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
            }
            
            <div className="mt-5">
                <p style={{lineHeight:"2"}}  dangerouslySetInnerHTML={{__html:description}}  />
            </div>
            {buttonObject &&
                <div className="my-5 text-center">
                      <AnchorLink 
                        {...buttonObject}
                      />
                </div>
            }            
        </>
    );
};

export default FullContent;